import React from 'react';
import { useI18n } from 'next-localization';

import { NeuImage } from '@hcahealthcaredpx/neutron-react';

import Section from '../section';

type Props = {
  fields: {
    appointmentInformation: {
      physicianName: string;
      appointmentTime?: string;
      hospitalName: string;
      address: string;
      city: string;
      appointmentType: string;
      reasonForVisit: string;
      physicianPhotoUrl: string;
    };
  };
};

const AppointmentInformationSection = ({ fields }: Props): JSX.Element => {
  const { t } = useI18n();

  return (
    <Section>
      <div className="row mb-2">
        <div className="mb-2">
          <h2 className="neu-display-4 pb-2 neu-text-gray-70">
            {t('OAS.Booking.Confirmation.ApptInformation')}
          </h2>
        </div>
        <div className="col-lg-5 col-md-6 col-12 mb-2">
          <div className="row">
            <div className="col-auto">
              <NeuImage
                src={fields.appointmentInformation.physicianPhotoUrl}
                width={170}
                height={170}
                alt={`Photo of ${fields.appointmentInformation.physicianName}`}
              />
            </div>
            <div className="col">
              <p className="neu-display-6 mb-1 neu-text-gray-70">
                {fields.appointmentInformation.physicianName}
              </p>
              <p className="neu-display-6 mb-1 neu-text-gray-70">
                {fields.appointmentInformation.appointmentTime}
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-12 mb-3">
          <div className="row">
            <div className="col-12">
              <p className="neu-display-6 mb-1 neu-text-gray-70">
                {t('OAS.Booking.Confirmation.Location')}
              </p>
            </div>
            <div className="col-12">
              <p className="neu-display-6 neu-text-gray-70">
                {fields.appointmentInformation.hospitalName}
              </p>
            </div>
            <div className="col-12">
              <p className="neu-display-6 neu-text-gray-70">
                {fields.appointmentInformation.address}
              </p>
            </div>
            <div className="col-12">
              <p className="neu-display-6 neu-text-gray-70">{fields.appointmentInformation.city}</p>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-12 mb-3">
          <p className="neu-display-6 mb-1 neu-text-gray-70">
            {t('OAS.Booking.Appointment.ApptType')}
          </p>
          <ul className="m-0">
            <li className="neu-display-6 neu-text-gray-70">
              <p className="neu-display-6 neu-text-gray-70">
                {fields.appointmentInformation.appointmentType}
              </p>
            </li>
          </ul>
        </div>
        <div className="col-12 mb-1">
          <p className="neu-display-6 neu-text-gray-70">
            {t('OAS.Booking.Confirmation.ReasonForVisit')}
          </p>
        </div>
        <div className="col-12">
          <p className="neu-display-6 neu-text-gray-70">
            {fields.appointmentInformation.reasonForVisit}
          </p>
        </div>
      </div>
    </Section>
  );
};

export default AppointmentInformationSection;
